import React, { Component } from 'react';

class Adsense extends Component {
	componentDidMount() {
		try {
			window.googletag.cmd.push(function() { window.googletag.display('div-gpt-ad-1536946797817-0'); });
	   } catch(e) {
	   		console.log(e);
	   }
	 //   window.setTimeout(function() {
		// 	if(window.googletag && window.googletag.pubads) window.googletag.pubads().refresh();
		// });
 	};

	render() {
		///1006759/ParkTopperInFeed
		return (
			<div id='div-gpt-ad-1536946797817-0' className="row_ad2">
			</div>
		);

		// return (
		// 	<div className="row_ad">
		// 		<ins className="adsbygoogle"
		// 		     data-ad-format="fluid"
		// 		     data-ad-layout-key="-i9+6+8-41+6e"
		// 		     data-ad-client="ca-pub-0176506581219642"
		// 		     data-ad-slot="8170575543"></ins>
		// 	</div>
		// );	
	}
}


export default Adsense;



// WEBPACK FOOTER //
// ./src/Adsense.js